import slugifyFn from 'slugify';

export const slugify = str => slugifyFn(str).toLowerCase();

export const delay = (ms = 500) => new Promise(resolve => setTimeout(resolve, ms));

export const mergeStyle = (...styles) => styles.filter(Boolean).join(' ');
